import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=0403ba28"
import script from "./Games.js?vue&type=script&lang=js&external"
export * from "./Games.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports